import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { InputX } from 'components'

const DataSearch = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: "기관 검색",
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className="form-group search-bar">
					<InputX type="text" placeholder="검색어를 입력해주세요." id="" />
					<i className="icon icon_search" />
				</div>
			</div>
		</div>
	)
}

export default DataSearch
